/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const marketplace_group_ticket_listed_warning = () => `Solange dieses Gruppenticket zum Verkauf angeboten wird, sind die einzelnen Tickets unten nicht für den Einlass oder die Nutzung gültig. Sie werden wieder aktiv, wenn das Angebot storniert wird, oder für den neuen Besitzer, falls verkauft.`
